import About from "./Parts/About";
import ExperienceAndSkills from "./Parts/ExperienceAndSkills";
import Highlights from "./Parts/Highlights";
import Reviews from "./Parts/Reviews";

export const DETAILS_SECTIONS = {
    highlights: Highlights,
    about: About,
    experienceAndSkills: ExperienceAndSkills,
    reviews: Reviews,
};

export type DetailsSection = keyof typeof DETAILS_SECTIONS;
